<template>
  <div class="main-page">
    <template v-if="showHeader">
      <section class="page-section">
        <div class="container">
          <div class="grid justify-content-between">
            <div class="col">
              <div class="">
                <div class="text-2xl text-primary font-bold">
                  G-Account Details
                </div>
                <small>Customer account added on the GWCL Mobile App</small>
              </div>
            </div>
          </div>
        </div>
      </section>
      <hr />
    </template>
    <section class="page-section pt-2">
      <div class="container">
        <div class="grid">
          <div class="col comp-grid">
            <div class="">
              <div class="">
                <div>
                  <div class="relative-position" style="min-height: 100px">
                    <template v-if="pageReady">
                      <div class="grid">
                        <div class="col">
                          <div class="" :class="{ card: !isSubPage }">
                            <div class="grid align-items-center">
                              <div class="col">Customer Details:</div>
                              <div class="col font-bold">
                                <Button
                                  class="p-button-text p-0"
                                  icon=""
                                  label="Click to view customer details"
                                  v-if="item.customer_id"
                                  @click="
                                    app.navigateTo(
                                      `/customers/view/${item.customer_id}`
                                    )
                                  "
                                />
                              </div>
                            </div>
                            <hr />
                            <div class="grid align-items-center">
                              <div class="col">E-Billing Customer ID:</div>
                              <div class="col font-bold">
                                {{ item.gwcl_customer_id }}
                              </div>
                            </div>
                            <hr />
                            <div class="grid align-items-center">
                              <div class="col">Account Name:</div>
                              <div class="col font-bold">
                                {{ item.account_name }}
                              </div>
                            </div>
                            <hr />
                            <div class="grid align-items-center">
                              <div class="col">Account Number:</div>
                              <div class="col font-bold">
                                {{ item.account_number }}
                              </div>
                            </div>
                            <hr />
                            <div class="grid align-items-center">
                              <div class="col">Meter Number:</div>
                              <div class="col font-bold">
                                {{ item.meter_number }}
                              </div>
                            </div>
                            <hr />
                            <div class="grid align-items-center">
                              <div class="col">Alias:</div>
                              <div class="col font-bold">
                                {{ item.meter_alias }}
                              </div>
                            </div>
                            <hr />
                            <div class="grid align-items-center">
                              <div class="col">Meter Type:</div>
                              <div class="col font-bold">
                                {{ item.meter_type }}
                              </div>
                            </div>
                            <hr />
                            <div class="grid align-items-center">
                              <div class="col">Service Category Name:</div>
                              <div class="col font-bold">
                                {{ item.service_category_name }}
                              </div>
                            </div>
                            <hr />
                            <div class="grid align-items-center">
                              <div class="col">Meter Status:</div>
                              <div class="col font-bold">
                                {{ item.meter_status }}
                              </div>
                            </div>
                            <hr />
                            <div class="grid align-items-center">
                              <div class="col">Last Reading:</div>
                              <div class="col font-bold">
                                {{ item.last_reading }}
                              </div>
                            </div>
                            <hr />
                            <div class="grid align-items-center">
                              <div class="col">Last Read Date:</div>
                              <div class="col font-bold">
                                {{ $utils.humanDatetime(item.last_read_date) }}
                              </div>
                            </div>
                            <hr />
                            <div class="grid align-items-center">
                              <div class="col">Last Bill Amount:</div>
                              <div class="col font-bold">
                                {{ item.last_bill_amount }}
                              </div>
                            </div>
                            <hr />
                            <div class="grid align-items-center">
                              <div class="col">Last Bill Date:</div>
                              <div class="col font-bold">
                                {{ $utils.humanDatetime(item.last_bill_date) }}
                              </div>
                            </div>
                            <hr />
                            <div class="grid align-items-center">
                              <div class="col">Avg Consume:</div>
                              <div class="col font-bold">
                                {{ item.avg_consume }}
                              </div>
                            </div>
                            <hr />
                            <div class="grid align-items-center">
                              <div class="col">Active:</div>
                              <div class="col font-bold">{{ item.active }}</div>
                            </div>
                            <hr />
                            <div class="grid align-items-center">
                              <div class="col">Digital Address:</div>
                              <div class="col font-bold">
                                {{ item.digital_address }}
                              </div>
                            </div>
                            <hr />
                            <div class="grid align-items-center">
                              <div class="col">Primary Phone Number:</div>
                              <div class="col font-bold">
                                {{ item.primary_phone_number }}
                              </div>
                            </div>
                            <hr />
                            <div class="grid align-items-center">
                              <div class="col">Secondary Phone Number:</div>
                              <div class="col font-bold">
                                {{ item.secondary_phone_number }}
                              </div>
                            </div>
                            <hr />
                            <div class="grid align-items-center">
                              <div class="col">Email Address:</div>
                              <div class="col font-bold">
                                {{ item.email_address }}
                              </div>
                            </div>
                            <hr />
                            <div class="grid align-items-center">
                              <div class="col">District Name:</div>
                              <div class="col font-bold">
                                {{ item.district_name }}
                              </div>
                            </div>
                            <hr />
                            <div class="grid align-items-center">
                              <div class="col">Region Name:</div>
                              <div class="col font-bold">
                                {{ item.region_name }}
                              </div>
                            </div>
                            <hr />
                            <div class="grid align-items-center">
                              <div class="col">Balance (GHS):</div>
                              <div class="col font-bold">
                                {{ item.balance }}
                              </div>
                            </div>
                            <hr />
                            <div class="grid align-items-center">
                              <div class="col">Date Created:</div>
                              <div class="col font-bold">
                                {{ $utils.humanDatetime(item.date_created) }}
                              </div>
                            </div>
                            <hr />
                            <div class="grid align-items-center">
                              <div class="col">Last Updated:</div>
                              <div class="col font-bold">
                                {{ $utils.humanDatetime(item.date_updated) }}
                              </div>
                            </div>
                            <hr />
                          </div>
                        </div>
                        <!-- Detal Page Column -->
                        <template v-if="currentRecord && !isSubPage">
                          <div class="col-12">
                            <div class="card my-3">
                              <component
                                :is="masterDetailPage"
                                :scroll-into-view="false"
                              ></component>
                            </div>
                          </div>
                        </template>
                      </div>
                    </template>
                    <template v-if="loading">
                      <div>
                        <table class="p-datatable-table w-full">
                          <tbody>
                            <tr v-for="n in 5" :key="n">
                              <td class="text-left" style="width: 100%">
                                <Skeleton height="3rem" class="m-2" />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script setup>
import { defineAsyncComponent, computed, toRefs, onMounted } from "vue";
import { utils } from "@/utils";
import { useApp } from "@/composables/app.js";
import { useViewPage } from "@/composables/viewpage.js";
//[--PAGE-IMPORT-STATEMENT--]
const props = defineProps({
  id: [String, Number],
  primaryKey: {
    type: String,
    default: "meter_id",
  },
  pageName: {
    type: String,
    default: "meters",
  },
  routeName: {
    type: String,
    default: "metersview",
  },
  apiPath: {
    type: String,
    default: "meters/view",
  },
  editButton: {
    type: Boolean,
    default: true,
  },
  deleteButton: {
    type: Boolean,
    default: true,
  },
  exportButton: {
    type: Boolean,
    default: true,
  },
  titleBeforeDelete: {
    type: String,
    default: "Delete record",
  },
  msgBeforeDelete: {
    type: String,
    default: "Record deleted successfully",
  },
  msgAfterDelete: {
    type: String,
    default: "Record deleted successfully",
  },
  showHeader: {
    type: Boolean,
    default: true,
  },
  showFooter: {
    type: Boolean,
    default: true,
  },
  isSubPage: {
    type: Boolean,
    default: false,
  },
});
const app = useApp(props);
const page = useViewPage(props); // page hook
//page state
const {
  item, // current record from store - Object
  loading, // api loading state
  pageReady, // api data loaded successfully
} = toRefs(page.state);
//page computed propties
const {
  apiUrl, // page current api path
  currentRecord, // current page record  - Object
} = page.computedProps;
//page methods
const {
  load, // load data from api
  deleteItem, // deleted current record
  exportPage, // export page records - args = (exportFormats, apiUrl, pageName)
  moveToNextRecord, // load next record from api
  moveToPreviousRecord, // load previous record from api
} = page.methods;
function getActionMenuModel(data) {
  return [];
}
const masterDetailPage = computed(() =>
  defineAsyncComponent(() => import("./detail-pages.vue"))
);
onMounted(() => {
  const pageTitle = "G-Account Details";
  app.setPageTitle(props.routeName, pageTitle); // set browser page title
  load();
});
</script>
<style scoped></style>
<style scoped></style>
